import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';
import { PaymentType as PaymentTypeENUM } from '@trnsact/trnsact-shared-types';
import { convertEnumToSelectOptions } from 'utils/selectOptionsHelper';

import { DealSheetRulesFilters } from './index';

export const PaymentType = () => {
  const { control } = useFormContext<DealSheetRulesFilters>();

  return (
    <AutocompleteField
      multiple
      size="small"
      control={control}
      name="PAYMENT_TYPE"
      disableCloseOnSelect
      options={convertEnumToSelectOptions(PaymentTypeENUM)}
      textFieldProps={{ variant: 'outlined', label: 'Payment Type' }}
    />
  );
};
